<template>
  <div class="gm-admin-tab">
    <div class="gm-admin-tab__head">
      <div>
        <h2>{{ $t('frontend_groovemail_admin_settings_verification_settings') }}</h2>
        <p class="gm-admin-tab__hint">{{ $t('frontend_groovemail_admin_configure_settings') }}</p>
      </div>
    </div>

    <div class="gm-admin-tab__toggle-row">
      <span>{{ this.$t('frontend_groovemail_admin_settings_sender_verification_required') }}</span>
      <gd-toggle
        bgClass="bg-grey-300"
        :value="model.senderVerificationRequired"
        @change="openConfirmationActionModal('verification')"
      />
    </div>
    <div class="gm-admin-tab__toggle-row">
      <span>{{ this.$t('frontend_groovemail_admin_enable_disable_maling_setting_toggle_text') }}</span>
      <gd-toggle
        bgClass="bg-grey-300"
        :value="model.mailing"
        @change="openConfirmationActionModal('mailing')"
      />
    </div>

    <!-- Confirmation delete modal -->
    <confirm-modal
      :ref="`confirmation-action`"
      :name="`confirmation-action`"
      :buttonText="$t('frontend_confirm')"
      :cancelText="$t('frontend_cancel')"
      :confirmMessage="this.$t('frontend_bouses_delete_bonus_title')"
      :messageContent="confirmMessage"
      @confirm="confirmAction"
      @close="closeConfirmationActionModal"
    />
  </div>
</template>

<script>
import { adminUrls } from '@/utils/urls.js';
import { getData, postData } from '@/utils/apiHelper.js';
import { showRequestErrorAlert } from '@/components/showDialog.js';

export default {
  data() {
    return {
      model: {
        senderVerificationRequired: 0,
        mailing: 0,
      },
      confirmMessage: '',
      confirmTarget: '',
    };
  },

  // Initialize data properties with verification/mailing data .
  async created() {
	  await Promise.all([
      this.initializeVerificationMailData(),
      this.initializeMailingData(),
    ]);
  },

  methods: {
    // Fetches verification data and initializes them to data properties.
    async initializeVerificationMailData() {
      try {
        const verificationRequired = await getData(
          adminUrls.mainSettingsUrl.fetchSenderVerificationSetting
        );
        this.model.senderVerificationRequired =
          verificationRequired &&
          verificationRequired.data &&
          verificationRequired.data.sender_verification_required;
      } catch (error) {
        // show error alert
        await showRequestErrorAlert(error?.response?.data?.error);
      }
    },

    // open confirmation action modal
    async openConfirmationActionModal(target) {
      this.confirmTarget = target;

      // set the Confirm message based on the target
      if (target === 'verification') {
        if (this.model.senderVerificationRequired) {
          this.confirmMessage = this.$t('frontend_groovemail_verification_settings_are_you_sure_not_required');
        } else {
          this.confirmMessage = this.$t('frontend_groovemail_verification_settings_are_you_sure_required');
        }
      } else if (target === 'mailing') {
        if (this.model.mailing) {
          this.confirmMessage = this.$t('frontend_groovemail_admin_enable_disable_maling_setting_are_you_sure_off');
        } else {
          this.confirmMessage = this.$t('frontend_groovemail_admin_enable_disable_maling_setting_are_you_sure_on');
        }
      }

      // open the modal
      this.$refs[`confirmation-action`].open();
    },

    // close confirmation action modal
    closeConfirmationActionModal() {
      // reset the Confirm data
      this.confirmMessage = '';
      this.confirmTarget = '';
    },

    confirmAction() {
      if (this.confirmTarget === 'verification') {
        this.changeVerification();
      } else if (this.confirmTarget === 'mailing') {
        this.changeMailingSetting();
      }
    },

    // Updates verification data
    async changeVerification() {
      try {
	      const verificationResponse = await postData(
          adminUrls.mainSettingsUrl.updateSenderVerificationSetting,
          {sender_verification_required: 1 - this.model.senderVerificationRequired,}
        );
        if (verificationResponse && verificationResponse.data && verificationResponse.data.data) {
          this.model.senderVerificationRequired = verificationResponse.data.data.sender_verification_required;
        }
      } catch (error) {
        // show error alert
        await showRequestErrorAlert(error?.response?.data?.error);
      }
    },

    // Updates mailing data
    async changeMailingSetting() {
      try {
	      const mailingResponse = await postData(
          adminUrls.mainSettingsUrl.updateMailingSetting,
          {user_can_mail: 1 - this.model.mailing,}
        );
        if (mailingResponse && mailingResponse.data) {
          this.model.mailing = mailingResponse.data.new_user_can_mail;
        }
      } catch (error) {
        // show error alert
        await showRequestErrorAlert(error?.response?.data?.error);
      }
    },

    // Fetches mailing data and initializes them to data properties.
    async initializeMailingData() {
      try {
        const mailingData = await getData(
          adminUrls.mainSettingsUrl.fetchMailingSetting
        );
        this.model.mailing = mailingData && mailingData.data && mailingData.data.new_user_can_mail;
      } catch (error) {
        // show error alert
        await showRequestErrorAlert(error?.response?.data?.error);
      }
    },
  },
};
</script>